import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import TabNavigation from "../../../components/TabNavigation/TabNavigation";
import CategoriesMenu from "../components/CategoriesMenu";
import { useTabState } from "../hooks/tabState";
import { useTranslation } from "react-i18next";
import { withTranslations } from "../../../hoc/withTranslations/withTranslations";
import { useAppSelector } from "../../../hooks/useAppDispatch"; // adjust path as needed
import { RootState } from "../../../redux/store"; // adjust path as needed

const LOCALE = "modules_MyGiftTable_pages_MyTable";

const MyTable: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  const navigate = useNavigate();

  // Read stickyOffset from Redux
  const stickyOffset = useAppSelector(
    (state: RootState) => state.uiState.stickyOffset
  );

  // Initialize with the translated "catalog" value.
  const [, setLastCategory] = useTabState("lastCategory", t("catalog"));

  useEffect(() => {
    // Reset the lastCategory when visiting MyTable
    setLastCategory(t("catalog"));
  }, [setLastCategory, t]);

  return (
    <MainLayout
      content={
        <TabNavigation
          stickyOffset={stickyOffset} // Pass the Redux value here
          tabs={[
            {
              label: t("catalog"),
              component: (
                <CategoriesMenu
                  onCategorySelect={(category) => {
                    if (category) {
                      navigate(
                        `/my-table/products?category=${category.name}&category_id=${category.id}`
                      );
                    } else {
                      navigate(`/my-table/products`);
                    }
                  }}
                />
              ),
              isActive: true,
            },
            {
              label: t("myProducts"),
              onClick: () => navigate("/my-table/my-products"),
              component: null,
              isActive: false,
            },
          ]}
        />
      }
    />
  );
};

export default withTranslations(LOCALE)(MyTable);
